import { useTreatmentInformationContext } from '@context/TreatmentInformation';
import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import {
  NAME_COMPLETE_BUTTON,
  NAME_INPUT
} from '@pages/PatientSetting/views/PatientNameInput/focuskey';
import { PATIENT } from '@router/path';
import constate from 'constate';
import { ChangeEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const usePatientName = () => {
  const navigate = useNavigate();
  const { setName, name } = useTreatmentInformationContext();

  const [isEmptyValue, setIsEmptyValue] = useState<boolean>(false);

  const isEmpty = (value: string) => {
    return value.trim() === '';
  };

  const validateEmptyValue = () => {
    if (isEmpty(name)) {
      setIsEmptyValue(true);
      return;
    }
    goResidentRegistrationNumber();
  };

  const goResidentRegistrationNumber = () => {
    navigate(PATIENT.RRN);
  };

  const setInputName = (e: ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  };

  const goPatientSelection = () => {
    navigate(-1);
  };

  const { setFocus } = useFocusable();

  const focusNameInput = () => {
    setFocus(NAME_INPUT);
  };
  const focusCompleteButton = () => {
    setFocus(NAME_COMPLETE_BUTTON);
  };

  return {
    goPatientSelection,
    setInputName,
    validateEmptyValue,
    focusNameInput,
    focusCompleteButton,
    name,
    isEmptyValue
  };
};

export const [PatientNameProvider, usePatientNameContext] = constate(usePatientName);
